<template>
	<div class="treatments">
		<div style="position: sticky; top:12px; z-index: 200;">
			<Breadcrumbs :items="items" />
		</div>
		<v-container fluid>
			<v-row no-gutters class="mt-4">
				<template v-for="treatment in treatments">
					<TreatmentCard
						v-if="treatment.permition || admin"
						:treatment="treatment"
						:key="treatment.name"
					/>
				</template>
				<TreatmentCard
					v-for="customTreatment in customTreatments"
					:treatment="customTreatment"
					:key="customTreatment.id"
					:custom="true"
					@edit-users="treatmentToEdit = customTreatment; getUsers()"
					@edit="treatmentToEdit = customTreatment; showEdit = true"
					:loading="loading"
				/>
				<v-col cols="12" md="4" class="px-2 treatment-card mb-5" v-if="$store.getters.hasRole('manager')">
					<v-card :disabled="!$store.getters.hasAnyModule" @click="showNewTreatment = true">
						<v-card-title>
							<v-row no-gutters align="center" justify="center">
								<v-icon large color="primary" class="my-2">mdi-plus-circle-outline</v-icon>
							</v-row>
						</v-card-title>
					</v-card>
				</v-col>
				<v-dialog v-model="showNewTreatment" max-width="40%">
					<v-card>
						<v-card-title class="primary--text mb-3 secondary">
							<v-icon color="primary" class="mr-2">mdi-clipboard-text</v-icon>
							<translate>New Treatment</translate>
						</v-card-title>
						<v-card-text>
							<v-row no-gutters>
								<v-col cols="12">
									<v-form ref="newTreatmentForm">
										<v-text-field
											v-model="newTreatmentName"
											:label="$gettext('Treatment Name')"
											outlined
											class="px-2"
											:rules="[required]"
										></v-text-field>
									</v-form>
								</v-col>
							</v-row>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-btn color="primary" text @click="showNewTreatment = false">
								<translate>Cancel</translate>
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="primary" text @click="addTreatment" :loading="loading">
								<translate>Add</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog v-model="showEdit" max-width="50%">
					<v-card>
						<v-card-title class="primary--text mb-3 secondary">
							<v-icon color="primary" class="mr-2">mdi-clipboard-text</v-icon>
							<translate>Edit Treatment</translate>
						</v-card-title>
						<v-card-text v-if="treatmentToEdit">
							<v-form ref="treatmentForm">
								<v-text-field
									v-model="treatmentToEdit.name"
									:label="$gettext('Treatment Name')"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-form>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-btn color="primary" text @click="showEdit = false; treatmentToEdit = null">
								<translate>Cancel</translate>
							</v-btn>
							<v-btn color="primary" @click="showDeleteAlert = true" :loading="loading">
								<v-icon>delete</v-icon>
								<translate>Delete</translate>
								<DeleteConfirmationDialog v-model="showDeleteAlert" item="treatment" @delete="removeTreatment(treatmentToEdit)" />
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="primary" text @click="editTreatment" :loading="loading">
								<translate>Save</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog v-model="showUsers" max-width="50%">
					<v-card v-if="treatmentToEdit && treatmentToEdit.users_in && treatmentToEdit.users_out">
						<v-card-title class="primary--text mb-3 secondary">
							<v-icon color="primary" class="mr-2">mdi-clipboard-text</v-icon>
							<translate>Manage Access</translate>
							<span class="mx-1">-</span>{{treatmentToEdit.name}}
						</v-card-title>
						<v-card-text>
							<p v-translate class="text-subtitle-1 mb-1">Terapeuts with access</p>
							<p v-if="treatmentToEdit.users_in.length == 0" class="font-weight-thin ml-2 my-2" key="current" v-translate>No professionals selected.</p>
							<v-list v-else flat>
								<v-list-item
									:key="user.id"
									style="border: 1px solid #e0e0e0; border-radius: 5px"
									v-for="user in treatmentToEdit.users_in"
								>
									<v-list-item-icon class="mr-3">
										<v-icon :color="user.color">person</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>
											<strong>{{user.name}}</strong>
										</v-list-item-title>
										<v-list-item-subtitle></v-list-item-subtitle>
									</v-list-item-content>
										<v-list-item-action>
												<v-btn icon @click="removeUser(user)">
													<v-icon color="primary">mdi-close-circle</v-icon>
												</v-btn>
										</v-list-item-action>
								</v-list-item>
							</v-list>
							<p class="text-subtitle-1 mb-1" v-translate>Other terapeuts</p>
							<p v-if="treatmentToEdit.users_out.length == 0" class="font-weight-thin ml-2 my-2" key="other" v-translate>No more professionals.</p>
							<v-list flat>
								<v-list-item
									:key="user.id"
									style="border: 1px solid #e0e0e0; border-radius: 5px"
									v-for="user in treatmentToEdit.users_out"
								>
									<v-list-item-icon class="mr-3">
										<v-icon :color="user.color">person</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>
											<strong>{{user.name}}</strong>
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-btn icon @click="addUser(user)">
											<v-icon color="primary">mdi-plus-circle</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-btn color="primary" text @click="showUsers = false; treatmentToEdit = null">
								<translate>Cancel</translate>
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="primary" text @click="editUsers" :loading="loading">
								<translate>Save</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import axios from "axios";
import TreatmentCard from "@/components/settings/TreatmentCard.vue";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
	name: "Treatments",
	components: {
		TreatmentCard,
		DeleteConfirmationDialog,
		Breadcrumbs
	},
	data: () => ({
		customTreatments: [],
		showNewTreatment: false,
    newTreatmentName: "",
    showEdit: false,
		showUsers: false,
		showDeleteAlert: false,
    treatmentToEdit: null,
    loading: false
	}),
	computed: {
		items() {
			return [
				{text: this.$gettext("Dashboard"), disabled: false, link: true, to: { name: "home" }},
        {text: this.$gettext("Treatments"), disabled: false, link: true, to: { name: "treatments" }}
			]
    },
		required() {
			return value => !!value || this.$gettext("Required.");
		},
		admin() {
			return this.$store.getters.hasRole("admin");
		},
		treatments() {
			const supplementsRoute = this.admin ? "admin-supplements" : "supplements";
			const cmmRoute = this.admin ? "admin-cmm" : "cmm";
			return [
				{
					name: this.$gettext("Supplements"),
					to: { name: supplementsRoute, params: { admin: this.admin } },
					icon: "mdi-pill",
					code: "sup",
					module: "fito",
					permition: this.$store.getters.hasModule("fito")
				},
				{
					name: this.$gettext("Nutrition"),
					to: {
						name: "pre-made-treatments",
						params: { category: "nut" }
					},
					icon: "mdi-food-apple",
					code: "nut",
					module: "fito",
					permition: this.$store.getters.hasAnyModule
				},
				{
					name: this.$gettext("Chinese Materia Medica"),
					to: { name: cmmRoute, params: { admin: this.admin } },
					icon: "mdi-beaker-outline",
					code: "cmm",
					module: "mtc",
					permition: this.$store.getters.hasModule("mtc")
				},
				{
					name: this.$gettext("Acupuncture"),
					to: {name: "acupuncture"},
					icon: "mdi-needle",
					code: "acu",
					module: "mtc",
					permition: this.$store.getters.hasModule("mtc")
				},
				{
					name: this.$gettext("Auricular Acupuncture"),
					to: {name: "auricular-acupuncture"},
					icon: "mdi-needle",
					code: "acu",
					module: "mtc",
					permition: this.$store.getters.hasModule("mtc")
				},
				{
					name: "Qi Gong",
					to: {
						name: "pre-made-treatments",
						params: { category: "qg" }
					},
					icon: "mdi-yoga",
					code: "qg",
					module: "mtc",
					permition: this.$store.getters.hasModule("mtc")
				},
				{
					name: "Tui Na",
					to: {
						name: "pre-made-treatments",
						params: { category: "tn" }
					},
					icon: "mdi-hand-front-right",
					code: "tn",
					module: "mtc",
					permition: this.$store.getters.hasModule("mtc")
				}
			]
		}
	},
	methods: {
    addTreatment() {
      if(this.$refs.newTreatmentForm.validate()) {
        this.loading = true;
        let form = new FormData();
        form.append("name", this.newTreatmentName);
        axios
          .post("/custom-treatments/new", form)
          .then(response => {
            console.log(response.data);
            if (response.data.result == "ok") {
              this.customTreatments.push(response.data.treatment);
              this.showNewTreatment = false;
            }
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
          });
      }
    },
    editTreatment() {
      if(this.$refs.treatmentForm.validate()) {
        this.loading = true;
        let form = new FormData();
        form.append("name", this.treatmentToEdit.name);
        axios
          .post("/custom-treatments/" + this.treatmentToEdit.id, form)
          .then(response => {
            console.log(response.data);
            if (response.data.result == "edited") {
              this.showEdit = false;
            }
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
          });
      }
    },
    removeTreatment(treatment) {
      this.loading = true;
      axios
				.post("/custom-treatments/" + treatment.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted") {
						this.customTreatments.splice(this.treatments.indexOf(treatment), 1);
						this.showDeleteAlert = false;
						this.showEdit = false;
          }
          this.loading = false;
				})
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    getUsers() {
      this.loading = true;
      axios
				.get("/custom-treatments/" + this.treatmentToEdit.id + "/users")
				.then(response => {
          console.log(response.data);
          this.$set(this.treatmentToEdit, 'users_in', response.data.users_in);
          this.$set(this.treatmentToEdit, 'users_out', response.data.users_out);
          this.loading = false;
          this.showUsers = true;
				})
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    editUsers() {
      this.loading = true;
      axios
				.post("/custom-treatments/" + this.treatmentToEdit.id + "/users", this.treatmentToEdit.users_in)
				.then(response => {
          console.log(response.data);
          this.loading = false;
          this.showUsers = false;
				})
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    removeUser(user) {
      this.treatmentToEdit.users_in.splice(this.treatmentToEdit.users_in.indexOf(user), 1);
      this.treatmentToEdit.users_out.push(user);
    },
    addUser(user) {
      this.treatmentToEdit.users_out.splice(this.treatmentToEdit.users_out.indexOf(user), 1);
      this.treatmentToEdit.users_in.push(user);
    }
  },
	created() {
    axios
			.get("/custom-treatments")
			.then(response => {
				console.log(response.data);
				if (response.status === 200) {
          this.customTreatments = response.data.custom_treatments;
				}
			})
			.catch(error => console.log(error));
  }
};
</script>